import { render, staticRenderFns } from "./vueDigitalMandates.vue?vue&type=template&id=1a88371c&scoped=true"
import script from "./vueDigitalMandates.vue?vue&type=script&lang=js"
export * from "./vueDigitalMandates.vue?vue&type=script&lang=js"
import style0 from "./vueDigitalMandates.vue?vue&type=style&index=0&id=1a88371c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a88371c",
  null
  
)

export default component.exports